export const selectDepartmentsList = (state) => state.departments.departments;
export const selectDepartmentsLoading = (state) => state.departments.loading;
export const selectDepartmentsError = (state) => state.departments.error;
export const selectDepartmentsSuccessMessage = (state) => state.departments.successMessage;
